import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=505b78c5&scoped=true"
import script from "./tabs.vue?vue&type=script&lang=js"
export * from "./tabs.vue?vue&type=script&lang=js"
import style0 from "./tabs.vue?vue&type=style&index=0&id=505b78c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505b78c5",
  null
  
)

export default component.exports